import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Section @gap={{@gap}} ...attributes>\n  <Layout::Wrapper>\n    {{yield}}\n  </Layout::Wrapper>\n</Layout::Section>")